import React from 'react';
import LeadsListFunctional from './components/leads-list-functional';

const LeadsList = () => {
	return <LeadsListFunctional />;
};

export default LeadsList;
